
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/k/[q]",
      function () {
        return require("private-next-pages/listing/k/[q]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/k/[q]"])
      });
    }
  